import { VoucherHolderType } from "@nkr/enums/voucher-holder-type";

export interface IMicrositeEventLog {
    id: number,
    micrositeRecipientId: number,
    eventType: number,
    eventDate: Date,
    eventRecordedDateTime: Date,
    isKidneyStillFunctioning: boolean,
    prevCenterId?: number,
    newCenterId?: number,
    voucherType?: VoucherHolderType,
    comment: string
}